import _ from "lodash"

class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return _.merge({}, filter, { status: ['active', 'inactive'] })
    }
  }

  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      const new_values = _.omit(values, ['status'])
      if (_.has(new_values, 'name'))
        _.merge(new_values, { name: { contains: new_values?.name } })
      return _.merge({}, new_values,
        _.get(values, 'status', []).length === 1 ? { active: _.includes(values.status, 'active') } : {})
    }
  }
}

export default Callbacks
